module.exports = __webpack_public_path__ + "img/qqyy.08f1b20e.jpg";